if (!customElements.get('ebike-product-description-link')) {
  customElements.define('ebike-product-description-link', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const link = this.querySelector('a[data-description-tab]');
      if (!link) return;
      this.controller = new AbortController();
      link.addEventListener('click', event => {
        const tab = document.getElementById(link.dataset.descriptionTab);
        if (!tab || tab.getAttribute('role') !== 'tab') return;
        event.preventDefault();
        tab.click();
        requestAnimationFrame(() => {
          tab.focus({ preventScroll: true });
          const target = tab.closest('[role="tablist"]') || tab;
          const offset = matchMedia('(max-width: 749px)').matches ? 125 : 185;
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({
            top: Math.max(0, top),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        });
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
